const translations = {
  translation: {
    appTitle: '単位変換',
    appDescription: '11種類のカテゴリで瞬時に単位変換',
    selectCategory: 'カテゴリーを選択',
    categories: {
      length: '長さ',
      mass: '質量',
      force: '力',
      energy: 'エネルギー',
      power: '電力',
      pressure: '圧力',
      temperature: '温度',
      time: '時間',
      volume: '容積',
      angle: '角度',
      area: '面積',
    },
    units: {
      meter: 'メートル',
      kilometer: 'キロメートル',
      centimeter: 'センチメートル',
      millimeter: 'ミリメートル',
      micrometer: 'マイクロメートル',
      nanometer: 'ナノメートル',
      mile: 'マイル',
      yard: 'ヤード',
      foot: 'フィート',
      inch: 'インチ',
      nauticalMile: '海里',
      kilogram: 'キログラム',
      gram: 'グラム',
      milligram: 'ミリグラム',
      metricTon: 'トン',
      pound: 'ポンド',
      ounce: 'オンス',
      ton: '米トン',
      stone: 'ストーン',
      newton: 'ニュートン',
      kilonewton: 'キロニュートン',
      poundForce: '重量ポンド',
      kilopoundForce: 'キロ重量ポンド',
      dyne: 'ダイン',
      joule: 'ジュール',
      kilojoule: 'キロジュール',
      calorie: 'カロリー',
      kilocalorie: 'キロカロリー',
      wattHour: 'ワット時',
      kilowattHour: 'キロワット時',
      electronvolt: '電子ボルト',
      btu: 'BTU',
      footPound: 'フィートポンド',
      watt: 'ワット',
      kilowatt: 'キロワット',
      megawatt: 'メガワット',
      horsepower: '馬力',
      btuPerHour: 'BTU/時',
      pascal: 'パスカル',
      kilopascal: 'キロパスカル',
      bar: 'バール',
      atmosphere: '気圧',
      psi: 'PSI',
      torr: 'トル',
      mmHg: '水銀柱ミリメートル',
      celsius: '摂氏',
      fahrenheit: '華氏',
      kelvin: 'ケルビン',
      second: '秒',
      millisecond: 'ミリ秒',
      microsecond: 'マイクロ秒',
      nanosecond: 'ナノ秒',
      minute: '分',
      hour: '時',
      day: '日',
      week: '週',
      month: '月',
      year: '年',
      liter: 'リットル',
      milliliter: 'ミリリットル',
      cubicMeter: '立方メートル',
      cubicCentimeter: '立方センチメートル',
      gallon: 'ガロン',
      quart: 'クォート',
      pint: 'パイント',
      cup: 'カップ',
      fluidOunce: '液量オンス',
      tablespoon: '大さじ',
      teaspoon: '小さじ',
      degree: '度',
      radian: 'ラジアン',
      gradian: 'グラード',
      arcminute: '分',
      arcsecond: '秒',
      turn: '回転',
      squareMeter: '平方メートル',
      squareKilometer: '平方キロメートル',
      squareCentimeter: '平方センチメートル',
      squareMillimeter: '平方ミリメートル',
      hectare: 'ヘクタール',
      acre: 'エーカー',
      squareMile: '平方マイル',
      squareYard: '平方ヤード',
      squareFoot: '平方フィート',
      squareInch: '平方インチ',
    },
    from: '変換元',
    to: '変換先',
    enterValue: '値を入力',
    result: '結果',
  },
};

export default translations;
